import './Header.css'
const Header = () =>{
    return (
      <>
      <div className='header'>
        <picture>
          <source media="(max-width:375px)" srcSet="./images/bg-header-mobile.svg"/>
          <img src="./images/bg-header-desktop.svg" alt="Flowers"/>
        </picture>
      </div>
      </>
    )
  }
export default Header